import React from "react"
import { Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faGithub } from "@fortawesome/free-brands-svg-icons"
import { faLink, faArrowLeft } from "@fortawesome/free-solid-svg-icons"

interface PageContentProps {
  title: string
  popupImageAlt?: string
  popupImageSrc?: string
  popupGithubLink?: string
  popupLiveLink?: string
  techIcons?: string[]
  video?: string
  html: string
}

const PageContent: React.FC<PageContentProps> = ({
  title,
  popupImageAlt,
  popupImageSrc,
  popupGithubLink,
  popupLiveLink,
  techIcons,
  video,
  html,
}) => {
  const techList = techIcons?.map(icon => (
    <li className="tech-pill tooltip" key={icon}>
      <span className="tooltiptext">
        {icon.charAt(0).toUpperCase() + icon.slice(1)}
      </span>
      <img
        className="svgIcon"
        src={`https://cdn.jsdelivr.net/npm/simple-icons@v5/icons/${icon}.svg`}
        alt={icon}
      />
    </li>
  ))

  return (
    <article className="page-content">
      <Link to="/" className="back-link">
        <FontAwesomeIcon icon={faArrowLeft} />
        <span>Back</span>
      </Link>

      <h1 className="page-title">{title}</h1>

      {popupImageSrc && video === "false" ? (
        <div className="page-image-wrap">
          <img
            src={
              /^https/.test(popupImageSrc)
                ? popupImageSrc
                : "/" + popupImageSrc
            }
            alt={popupImageAlt || title}
            className="page-image"
          />
        </div>
      ) : null}

      {video && video !== "false" ? (
        <div className="page-image-wrap">
          <video
            controls
            autoPlay
            muted
            loop
            playsInline
            className="page-image"
          >
            <source src={video} type="video/mp4" />
          </video>
        </div>
      ) : null}

      {(popupGithubLink || popupLiveLink) && (
        <div className="page-links">
          {popupLiveLink ? (
            <a
              href={popupLiveLink}
              target="_blank"
              rel="noopener noreferrer"
              className="page-link-pill"
            >
              <FontAwesomeIcon icon={faLink} />
              <span>Live</span>
            </a>
          ) : null}
          {popupGithubLink ? (
            <a
              href={popupGithubLink}
              target="_blank"
              rel="noopener noreferrer"
              className="page-link-pill"
            >
              <FontAwesomeIcon icon={faGithub} />
              <span>GitHub</span>
            </a>
          ) : null}
        </div>
      )}

      <div
        className="page-prose"
        dangerouslySetInnerHTML={{ __html: html }}
      />

      {techIcons && techIcons.length > 0 ? (
        <div className="page-stack">
          <h4>Tech stack</h4>
          <ul className="techItemsList">{techList}</ul>
        </div>
      ) : null}
    </article>
  )
}

export default PageContent
